<template>
  <div>
    <!--ON LOGS -->
    <ed-modal
      :title="titleLogsReq + ' Lote ' + this.formData.lote"
      width="60%"
      :modal="showLogsReq"
      :isModal="false"
    >
      <el-row slot="modal-content">
        <XmlViewer :xml="messageLogsReq" />
      </el-row>
    </ed-modal>

    <ed-modal
      :title="
        'STATUS PROCESSAMENTO -  ' +
        (formDataLogs.protocolo ? formDataLogs.protocolo : '')
      "
      width="60%"
      :modal="showLogs"
      :isModal="false"
    >
      <el-row slot="modal-content">
        <table class="table">
          <thead>
            <tr>
              <th width="150">Status</th>
              <th>Mensagem</th>
            </tr>
          </thead>

          <tbody v-for="(retorno, i) in formDataLogs.log_retorno" :key="i">
            <tr>
              <td align="left">{{ retorno.cdResposta }}</td>
              <td align="left">{{ retorno.descResposta }}</td>
            </tr>

            <tr v-if="retorno.uid">
              <td align="left" style="background: #fce6d9"><b>Arquivo</b></td>
              <td align="left" style="background: #fce6d9">
                <b>{{ retorno.uid }}</b>

                <label v-if="retorno.recibo" style="color: green">
                  <b>Recibo: </b> {{ retorno.recibo }}
                </label>
                <label v-if="retorno.funcionario" style="display:block">
                  {{ retorno.funcionario }}
                </label>
              </td>
            </tr>

            <template v-if="retorno.ocorrencias">
              <tr v-for="(ocorrencia, j) in retorno.ocorrencias" :key="i + j">
                <td align="left" style="color: red">
                  {{ ocorrencia.codigo }}
                </td>
                <td align="left" style="color: red">
                  {{ ocorrencia.descricao }} <span v-if="ocorrencia.localizacao">em {{ocorrencia.localizacao}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-row>
    </ed-modal>

    <!--TIPO MODO -->
    <ed-modal
      title="SELECIONE O MODO DE TRANSMISSÃO DO ARQUIVO"
      :modal="showModo"
      :isModal="false"
      width="70%"
    >
      <el-row slot="modal-content">
        <el-alert type="info" show-icon :closable="false">
          <b>ORIENTAÇÕES</b>
          <br />
          <b>Inclusão:</b>
          Selecione esta opção na primeira vez que enviar o lote ou quando a
          tentativa de inclusão foi rejeitada.
          <br />

          <b>Alteração:</b>
          Selecione esta opção para alterar o evento. Nesse ponto deve existir
          um lote de inclusão enviado.
          <br />

          <!-- <b>Exclusão:</b>
          Selecione esta opção para excluir o evento. Nesse ponto deve existir
          um lote de inclusão ou alteração enviado.
          <br /> -->

          <span v-if="tableData && tableData.length > 0" style="color: #21bc4d">
            <b>Último Lote Enviado:</b>
            {{ parseModo(tableData[0]._data.modo) }} em
            {{ toDate(tableData[0]._data.created_at, false) }}

            <span
              style="font-size: 9pt; color: red"
              v-if="tableData[0]._data.status != '201'"
              ><br />Lote não processado. Verifique o detalhamento do
              processamento.</span
            >
            <br />
          </span>
        </el-alert>

        <div class="col-md-12 text-center" style="margin-top: 25px">
          <el-button
            type="success"
            @click="onRegister(null, 'inc')"
            style="width: 150px"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
            Inclusão
          </el-button>

          <el-button
            v-if="formData && formData.layout != 'S-3000'"
            type="primary"
            @click="onRegister(null, 'alt')"
            style="width: 150px"
          >
            <i class="fa fa-save" aria-hidden="true"></i>
            Alteração
          </el-button>

          <!-- <el-button
            type="danger"
            @click="onRegister(null, 'exc')"
            :disabled="!checkEnableModo('EXC')"
            style="width: 150px"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
            Exclusão
          </el-button> -->
        </div>
      </el-row>
    </ed-modal>

    <ed-table
      registerName="Processar Lote"
      :onRegister="onRegister"
      :onSearch="getEsocialLotesProcessar"
      :onEdit="null"
      :onDelete="null"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingContent"
      :pagination="pagination"
    />
  </div>
</template>

<script>
import EdTable from "common/table";
import XmlViewer from "vue-xml-viewer";
import {
  EdForm,
  EdInputSelect,
  EdInputText,
  EdModal,
  EdButton,
} from "template";

export default {
  name: "esocial-lotes-processar",
  mixins: [],
  components: { EdTable, EdForm, EdModal, XmlViewer, EdInputText, EdButton },
  inject: ["parent"],
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    formData() {
      this.getEsocialLotesProcessar();
    },

    showForm() {},
  },

  data() {
    return {
      loadingContent: false,
      loadingConsultarLote: false,
      showFormDialog: false,
      showLogs: false,
      showModo: false,
      showConsultarOutrosLotes: false,
      titleLogsReq: null,
      showLogsReq: false,
      messageLogsReq: null,
      pagination: {},
      formDataLogs: {},
      tableHead: [
        {
          key: "id",
          sortable: true,
          width: "150px",
          label: "ID",
        },
        {
          key: "modo",
          label: "Modo",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "mensagem",
          label: "Mensagem",
        },
        {
          key: "protocolo",
          label: "Protocolo",
        },
        // {
        //   key: "recibo",
        //   label: "Recibo",
        // },
        {
          key: "data_recepcao",
          label: "Data Recepção",
        },
        {
          key: "data_envio",
          label: "Data Envio",
        },
      ],
      tableData: [],
      formDataProtocolo: {
        strProtocolo: null,
        arrayProtocolo: null,
      },
      boolExibirConsultaProtocolo: false,
    };
  },

  mounted() {
    this.getEsocialLotesProcessar();
  },

  methods: {
    toDate: function (date, disabledHours) {
      return this.$utilidade.toDate(date, disabledHours);
    },

    getEsocialLotesProcessar() {
      if (!this.formData.id) return;

      this.loadingContent = true;

      this.$root.$request
        .get("esocial/lotes/processar/" + this.formData.id)
        .then((result) => {
          this.loadingContent = false;

          if (result.status == 200) {
            this.formataLista(result);
          }
        });
    },

    onRegister(data, modo) {
      if (!modo) {
        this.showModo = !this.showModo;
        return;
      }

      let self = this;
      this.$root.$dialog
        .confirm("Tem certeza que deseja enviar esse lote para o eSocial?")
        .then(() => {
          self.$root.$loading.set(true);

          self.$root.$request
            .get(
              "esocial/lotes/processar/" +
                self.formData.id +
                "/enviar-lote/" +
                modo
            )
            .then((result) => {
              self.$root.$loading.set(false);

              if (result.status == 200) {
                self.formataLista(result);
                self.showModo = false;
              } else if(result.msg) {
                self.$root.$dialog.alert(result.msg, "error");
              }
            });
        });
    },

    consultarProtocolo() {
      if (!this.formDataProtocolo.strProtocolo) {
        this.$root.$dialog.alert("Informe o protocolo", "error");
        return;
      }

      this.$root.$loading.set(true);
      this.formDataProtocolo.arrayProtocolo = null;

      this.$root.$request
        .get(
          "esocial/lotes/consultar/" +
            this.formData.id +
            "/" +
            this.formDataProtocolo.strProtocolo
        )
        .then((result) => {
          this.$root.$loading.set(false);

          console.log("result", result);

          if (result.status == 200) {
            this.formDataProtocolo.arrayProtocolo = result.data;
          } else if(result.msg){
            this.$alert(result.msg, "Atenção", {
              confirmButtonText: "OK",
            });
          }
        });
    },

    onAtualizarProtocolo(data) {
      this.loadingContent = true;

      this.$root.$request
        .get(
          "esocial/lotes/processar/" +
            this.formData.id +
            "/" +
            data.id +
            "/consultar-lote"
        )
        .then((result) => {
          this.loadingContent = false;

          if (result.status == 200) {
            this.formataLista(result);
            this.parent.getEsocialLotes();
          } else if(result.msg){
            this.$alert(result.msg, "Atenção", {
              confirmButtonText: "OK",
            });
          }
        });
    },

    onLogs(data) {
      this.formDataLogs = data;
      this.showLogs = !this.showLogs;
    },

    onLogsReqSend(data) {
      this.titleLogsReq = "Dados enviados";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_request;
    },

    onLogsReqReceiv(data) {
      this.titleLogsReq = "Dados recebidos";
      this.showLogsReq = !this.showLogsReq;
      this.messageLogsReq = data.log_response;
    },

    parseModo: function (modo) {
      if (!modo) return;

      return modo
        .replace("INC", "Inclusão")
        .replace("ALT", "Alteração")
        .replace("EXC", "Exclusão");
    },

    checkEnableModo: function (modo) {
      var last_modo = this.tableData.length ? this.tableData[0]._data.modo : "",
        last_status = this.tableData.length
          ? this.tableData[0]._data.status
          : "";

      switch (modo) {
        case "INC":
          if (["", "INC"].indexOf(last_modo) != -1 && last_status != "201") {
            return true;
          }

          return false;

          break;

        case "ALT":
          if (
            (["ALT", "INC"].indexOf(last_modo) != -1 && last_status == "201") ||
            (["ALT", "EXC"].indexOf(last_modo) != -1 && last_status != "201")
          ) {
            return true;
          }

          return false;

          break;

        case "EXC":
          if (
            (["ALT", "INC"].indexOf(last_modo) != -1 && last_status == "201") ||
            (["EXC", "ALT"].indexOf(last_modo) != -1 && last_status != "201")
          ) {
            return true;
          }

          return false;

          break;
      }

      return false;
    },

    formataLista(result) {
      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].loading = false;
        arrData[i].log_retorno = arrData[i].log_retorno
          ? this.$utilidade.stringToArray(arrData[i].log_retorno)
          : null;

        var item = {
          id: arrData[i].id,
          modo: this.parseModo(arrData[i].modo),
          status: arrData[i].status,
          mensagem: arrData[i].msg,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          request: arrData[i].request,
          response: arrData[i].response,
          data_recepcao: this.$utilidade.toDate(
            arrData[i].data_recepcao,
            false
          ),
          data_envio: this.$utilidade.toDate(arrData[i].created_at, false),
          _data: arrData[i],
          buttons: [],
          options: {},
        };

        item.buttons.push({
          icon: "fa fa-refresh",
          color: "primary",
          title: "Consultar Protocolo",
          click: this.onAtualizarProtocolo,
        });

        if (arrData[i].log_retorno && arrData[i].log_retorno.length > 0) {
          item.buttons.push({
            icon: "fa fa-search",
            color: "warning",
            title: "Detalhes do Envio",
            click: this.onLogs,
          });

          if (arrData[i].log_request) {
            item.buttons.push({
              icon: "fa fa-cloud-upload",
              color: "warning",
              title: "Visualizar dados enviados",
              click: this.onLogsReqSend,
            });
          }

          if (arrData[i].log_response) {
            item.buttons.push({
              icon: "fa fa-cloud-download",
              color: "warning",
              title: "Visualizar dados recebidos",
              click: this.onLogsReqReceiv,
            });
          }
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?7f133924